<!--
 * @Author: wangxiaoheng
 * @Date: 2023-12-07 15:33:32
 * @LastEditors: wangxiaoheng
 * @LastEditTime: 2023-12-08 16:33:06
 * @FilePath: \saas_dev\src\components\pub\MaskLoading.vue
 * @Description: 
 * 
 * 
-->
<template>
  <div
    :class="['mask-loading', loading ? 'loading' : 'unloading']"
    :style="{ 'display': show ? 'block' : 'none' }"
  >
    <van-overlay :show="loading">
      <van-loading size="24px" color="#fff"
        ><span v-if="hasTxt">{{ text }}</span></van-loading
      >
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    hasTxt: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: "加载中…"
    }
  },
  data() {
    return {
      show: true
    };
  },
  watch: {
    // css动画无法描述 display
    loading(v) {
      if (!v) {
        setTimeout(() => {
          this.show = v;
        }, 800);
      } else {
        this.show = v;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes hiddenloading {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
.mask-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 1000;
  top: 0;
  &.loading {
    display: block;
  }
  &.unloading {
    animation: 0.8s hiddenloading forwards;
  }
  .van-overlay {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
}
</style>
